import { matchPatterns } from "@textlint/regexp-string-matcher";
export const messages = {
    BasicAuth: {
        en: (props) => `found basic auth credential: ${props.CREDENTIAL}`,
        ja: (props) => `ベーシック認証情報: ${props.CREDENTIAL} がみつかりました`,
    },
};
function reportIfFoundBasicAuth({ source, options, context, t, }) {
    // https://developer.mozilla.org/docs/Web/HTTP/Authentication
    // https://ihateregex.io/expr/url
    const URL_PATTERN = /(?<protocol>(:?[-a-zA-Z0-9_]{1,256})):\/\/(?<user>[-a-zA-Z0-9_]{1,256}):(?<password>[-a-zA-Z0-9_]{1,256})@[-a-zA-Z0-9%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b/g;
    const results = source.content.matchAll(URL_PATTERN);
    for (const result of results) {
        const index = result.index || 0;
        const match = result[0] || "";
        const range = [index, index + match.length];
        const allowedResults = matchPatterns(match, options.allows);
        if (allowedResults.length > 0) {
            continue;
        }
        context.report({
            message: t("BasicAuth", {
                CREDENTIAL: match,
            }),
            range,
        });
    }
}
export const creator = {
    messages,
    meta: {
        id: "@secretlint/secretlint-rule-basicauth",
        recommended: true,
        type: "scanner",
        supportedContentTypes: ["text"],
        docs: {
            url: "https://github.com/secretlint/secretlint/blob/master/packages/%40secretlint/secretlint-rule-basicauth/README.md",
        },
    },
    create(context, options) {
        const t = context.createTranslator(messages);
        const normalizedOptions = {
            allows: options.allows || [],
        };
        return {
            file(source) {
                reportIfFoundBasicAuth({ source, options: normalizedOptions, context, t });
            },
        };
    },
};
//# sourceMappingURL=index.js.map